import { LOCALE } from "../../thor.const";
import { SaleTranslationsStatus } from "../../typings/translations";
import { TranslationsDialogController } from "./translations-dialog.controller";

export class TranslationsMixinController {
    protected getTranslationStatus: Function;
    protected setTranslationStatus: Function;
    protected fetchAll: Function;
    protected initiatePublish: Function;
    protected currentLocale: string;
    protected isPublishDisabled: boolean;
    protected resourceId: number;
    protected translationsStatus: SaleTranslationsStatus;

    protected $t;

    constructor(
        protected $mdDialog: ng.material.IDialogService,
        protected $scope,
        protected $translate: ng.translate.ITranslateService,
        protected toaster
    ) {
        this.$t = $translate.instant;
        this.currentLocale = $translate.use() || (LOCALE as string);

        $scope.translationsStatus = this.translationsStatus;

        $scope.$watch(
            () => this.translationsStatus,
            current => {
                if (current) {
                    $scope.translationsStatus = this.translationsStatus;
                }
            },
            true
        );
    }

    public openTranslationConfirmationDialog(event) {
        this.$mdDialog
            .show({
                autoWrap: false,
                bindToController: true,
                controller: TranslationsDialogController,
                controllerAs: "ctrl",
                clickOutsideToClose: false,
                escapeToClose: false,
                preserveScope: true,
                scope: this.$scope,
                locals: {
                    getTranslationStatus: this.getTranslationStatus,
                    setTranslationStatus: $event => this.setTranslationStatus({ $event }),
                    fetchAll: $event => this.fetchAll({ $event }),
                    initiatePublish: $event => this.initiatePublish({ $event }),
                    currentLocale: this.currentLocale,
                    isPublishDisabled: this.isPublishDisabled,
                    resourceId: this.resourceId
                },
                targetEvent: event,
                template: require("./translations-dialog.html")
            })
            .then(
                () => null,
                ({ isTranslationDone } = { isTranslationDone: false }) =>
                    isTranslationDone && this.toaster.show(this.$t("translations.toaster.sale.done"))
            )
            .catch(angular.noop);
    }
}
